import axios from "./axios";

// Promang IFC Viewer integration.
// Models + alignment transforms are stored in Promang API; the 3D rendering is
// served by the standalone Promang IFC Viewer service via a short-lived session.

export async function fetchIfcModels(projectId) {
  return axios
    .get(`/projects/${projectId}/ifc_models`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}

export async function createIfcModel(projectId, payload, { replaceExisting = false } = {}) {
  return axios
    .post(`/projects/${projectId}/ifc_models`, {
      ifc_model: payload,
      replace_existing: replaceExisting,
    })
    .then((response) => response.data);
}

export async function updateIfcModel(projectId, id, payload) {
  return axios
    .put(`/projects/${projectId}/ifc_models/${id}`, { ifc_model: payload })
    .then((response) => response.data);
}

export async function deleteIfcModel(projectId, id) {
  return axios
    .delete(`/projects/${projectId}/ifc_models/${id}`)
    .then((response) => response.data);
}

/**
 * Start a viewer session. `body` narrows the federated scene:
 * `{ drawing_house_id, model_ids, include_hidden, focus }` where `focus` is
 * `{ x, y, z, storey_name }` in IFC coordinates.
 */
export async function createIfcViewerSession(projectId, body = {}) {
  return axios
    .post(`/projects/${projectId}/ifc_viewer_sessions`, body)
    .then((response) => response.data);
}

// Drawing <-> IFC alignment: two matched point pairs (PDF points and IFC
// coordinates) that let Promang translate a click on a drawing into a 3D point.

export async function fetchDrawingIfcAlignments(projectId, params = {}) {
  return axios
    .get(`/projects/${projectId}/drawing_ifc_alignments`, { params })
    .then((response) => response.data);
}

export async function createDrawingIfcAlignment(projectId, payload) {
  return axios
    .post(`/projects/${projectId}/drawing_ifc_alignments`, {
      drawing_ifc_alignment: payload,
    })
    .then((response) => response.data);
}

export async function updateDrawingIfcAlignment(projectId, id, payload) {
  return axios
    .put(`/projects/${projectId}/drawing_ifc_alignments/${id}`, {
      drawing_ifc_alignment: payload,
    })
    .then((response) => response.data);
}

export async function deleteDrawingIfcAlignment(projectId, id) {
  return axios
    .delete(`/projects/${projectId}/drawing_ifc_alignments/${id}`)
    .then((response) => response.data);
}

/**
 * Map a point on a drawing (PDF points) to the federated model. Returns the
 * project/house to open plus the focus point in IFC coordinates.
 * Pass `page` for multi-page drawings. Does not open the IFC tab — the host
 * creates its own viewer session after receiving `focus`.
 */
export async function openDrawingIn3d(drawingId, { x, y, page, ...rest } = {}) {
  const payload = { x, y, ...rest };
  if (page !== undefined && page !== null) payload.page = page;
  return axios
    .post(`/drawings/${drawingId}/open_in_3d`, payload)
    .then((response) => response.data);
}
